const domain: string = 'DOSSIER'

export const SAVE_DOSSIER: string = `${domain}/SAVE_DOSSIER`
